import InputEmail from '@portalterreno/nextjs-client/components/InputEmail';
import InputName from '@portalterreno/nextjs-client/components/InputName';
import InputPhone from '@portalterreno/nextjs-client/components/InputPhone';
import React from 'react';

import TermsAndConditions from '../../../TermsAndConditions';
import ReCaptchaTAC from '../../../TermsAndConditions/ReCaptchaTAC';
import TACDiv from '../../../TermsAndConditions/TACDiv';

export type WhatsappModalFormContentProps = {
  formHeader: React.ReactElement;
};

const WhatsappModalFormContent: React.FC<WhatsappModalFormContentProps> = ({
  formHeader: FormHeader
}) => {
  return (
    <React.Fragment>
      {FormHeader}
      <InputName />
      <InputEmail />
      <InputPhone />
      <TACDiv>
        <TermsAndConditions />
        <ReCaptchaTAC />
      </TACDiv>
    </React.Fragment>
  );
};

export default WhatsappModalFormContent;
